import Decimal from "decimal.js";
import { DECIMAL_STRING_REGEX } from "./constants.js";
/**
 * decimal.js wrappers. The whole codebase routes money through these helpers
 * so the "string ↔ Decimal" boundary is one well-known set of functions.
 */
Decimal.set({
    precision: 28,
    rounding: Decimal.ROUND_HALF_UP,
});
export const ZERO_CHF = "0.00";
export function decimalFromString(value) {
    if (!DECIMAL_STRING_REGEX.test(value)) {
        throw new Error(`Invalid decimal CHF string: ${JSON.stringify(value)}`);
    }
    return new Decimal(value);
}
/** Format a Decimal (or a number from inside a formatter) to "N.NN". */
export function formatDecimal(value) {
    const d = typeof value === "string" ? decimalFromString(value) : value;
    return d.toFixed(2);
}
export function addDecimals(...values) {
    return values.reduce((acc, v) => acc.plus(typeof v === "string" ? decimalFromString(v) : v), new Decimal(0));
}
export function multiplyDecimal(value, factor) {
    if (!Number.isInteger(factor) || factor < 0) {
        throw new Error(`Multiplier must be a non-negative integer: ${factor}`);
    }
    const d = typeof value === "string" ? decimalFromString(value) : value;
    return d.mul(factor);
}
export function subtractDecimals(a, b) {
    const da = typeof a === "string" ? decimalFromString(a) : a;
    const db = typeof b === "string" ? decimalFromString(b) : b;
    return da.minus(db);
}
export function isValidDecimalString(value) {
    return typeof value === "string" && DECIMAL_STRING_REGEX.test(value);
}
/** Compare two decimal strings; returns -1 / 0 / 1. */
export function compareDecimals(a, b) {
    return decimalFromString(a).cmp(decimalFromString(b));
}
export { Decimal };
//# sourceMappingURL=money.js.map